export const classCssTiers = {
  GOLD: 'gold',
  PLATINUM: 'platinum',
  TITANIUM: 'titanium',
  SILVER: 'silver',
  'CABALLERO AGUILA': 'caballero'
}

export const cobrandLevels = {
  AMXPLT: 'texto',
  SANTANDER: 'texto',
}
